(function() {
  let lastKnownSelections = { option1: null, option2: null, option3: null };
  const sectionId = window.overflowVariantsConfig.sectionId;
  const productId = window.overflowVariantsConfig.productId;
  // option selects get a chance to fall back and rewrite the URL.
  const initialVariantIdFromUrl = new URLSearchParams(window.location.search).get('variant');
  let allVariants = [];

  function setMwApoVariants(variants) {
  if (window.mwApoInit && window.mwApoInit.product) {
    window.mwApoInit.product.variants = variants;
    return;
  }

  let attempts = 0;
  const maxAttempts = 50;
  const interval = setInterval(() => {
    attempts++;
    if (window.mwApoInit && window.mwApoInit.product) {
      window.mwApoInit.product.variants = variants;
      clearInterval(interval);
    } else if (attempts >= maxAttempts) {
      clearInterval(interval);
    }
  }, 100);
  }

    const allVariantsPromise = fetch(`https://app.premiertablelinens.com/variants/${productId}`)
    .then(res => res.json())
    .then(data => {
      allVariants = data.variants;
      setMwApoVariants(data.variants);
      return data.variants;
    });

  async function loadAllVariants() {
    await allVariantsPromise;
  }

  // Shared sorter: numeric ascending if every value looks numeric, else preserve given order.
function sortValuesSmart(values, positionLookup) {
  const numericOf = (val) => {
    const match = val.match(/-?\d+(\.\d+)?/);
    return match ? parseFloat(match[0]) : null;
  };

  const allNumeric = values.every(v => numericOf(v) !== null);

  if (allNumeric) {
    return [...values].sort((a, b) => numericOf(a) - numericOf(b));
  }
  if (positionLookup) {
    return [...values].sort((a, b) => positionLookup(a) - positionLookup(b));
  }
  return values;
}

function buildOrderedValues(variants, optionKey) {
  const posMap = new Map();
  variants.forEach(v => {
    const val = v[optionKey];
    if (!val || val.includes('#MWS')) return;
    if (!posMap.has(val) || v.position < posMap.get(val)) {
      posMap.set(val, v.position);
    }
  });

  const values = [...posMap.keys()];

  // option1 stays in original position order — only option2/option3 get numeric-sorted.
  if (optionKey === 'option1') {
    return values.sort((a, b) => posMap.get(a) - posMap.get(b));
  }

  return sortValuesSmart(values, (val) => posMap.get(val));
}

function getValidValues(fixedKey, fixedValue, targetKey) {
  const posMap = new Map();
  allVariants
    .filter(v => v[fixedKey] === fixedValue && v[targetKey] && !v[targetKey].includes('#MWS'))
    .forEach(v => {
      if (!posMap.has(v[targetKey]) || v.position < posMap.get(v[targetKey])) {
        posMap.set(v[targetKey], v.position);
      }
    });

  const values = [...posMap.keys()];
  return sortValuesSmart(values, (val) => posMap.get(val));
}
  function rebuildOptionSelects(scope) {
    scope.querySelectorAll('select[data-index]').forEach(select => {
      const idx = select.dataset.index;
      const currentValue = select.value;
      const values = buildOrderedValues(allVariants, idx);
      if (values.length === 0) return;

      select.innerHTML = '';
      values.forEach(v => {
        select.appendChild(new Option(v, v, false, v === currentValue));
      });
    });
  }

  function reassertDependentSelect(scope, changedIndex) {
    const feetSelect = scope.querySelector('[data-index="option1"]');
    const heightSelect = scope.querySelector('[data-index="option2"]');
    const durationSelect = scope.querySelector('[data-index="option3"]');
    if (!feetSelect || !heightSelect) return;

    if (changedIndex === 'option1') {
      const validHeights = getValidValues('option1', feetSelect.value, 'option2');
      if (validHeights.length > 0) {
      const current = validHeights.includes(heightSelect.value)
        ? heightSelect.value
        : lastKnownSelections.option2;
        heightSelect.innerHTML = '';
        validHeights.forEach(v => heightSelect.appendChild(new Option(v, v, false, v === current)));
        if (!validHeights.includes(current)) heightSelect.value = validHeights[0];
      }
    }

    if (durationSelect) {
      const validDurations = [...new Set(
        allVariants
          .filter(v => v.option1 === feetSelect.value && v.option2 === heightSelect.value && v.option3 && !v.option3.includes('#MWS'))
          .map(v => v.option3)
      )];
      if (validDurations.length > 0) {
        const current = durationSelect.value;
        durationSelect.innerHTML = '';
        validDurations.forEach(v => durationSelect.appendChild(new Option(v, v, false, v === current)));
        if (!validDurations.includes(current)) durationSelect.value = validDurations[0];
      }
    }
  }

  function findVariant(values) {
    return allVariants.find(v =>
      (v.option1 || null) === (values[0] || null) &&
      (v.option2 || null) === (values[1] || null) &&
      (v.option3 || null) === (values[2] || null)
    );
  }

  function getScope() {
    const hiddenSelect = document.getElementById(`ProductSelect-${sectionId}`);
    return hiddenSelect ? hiddenSelect.closest('form') : null;
  }

  function getCurrentSelections(scope) {
    const values = [null, null, null];
    scope.querySelectorAll('[data-index]').forEach(el => {
      const idx = parseInt(el.dataset.index.replace('option', ''), 10) - 1;
      if (el.type === 'radio') {
        if (el.checked) values[idx] = el.value;
      } else {
        values[idx] = el.value;
      }
    });
    return values;
  }

  function getThemeContainer(scope) {
    return scope.closest('[data-section-id]');
  }

  function formatMoney(cents) {
    if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
      return window.theme.Currency.formatMoney(cents, window.theme.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  const fullVariantCache = new Map();

  async function fetchFullVariant(variantId) {
    if (fullVariantCache.has(variantId)) return fullVariantCache.get(variantId);
    const res = await fetch(`https://premiertablelinens.com/variants/${variantId}.js`);
    const data = await res.json();
    fullVariantCache.set(variantId, data);
    return data;
  }

  function syncAddToCartState(scope, fullVariant) {
    const themeContainer = getThemeContainer(scope);
    if (!themeContainer) { return; }

    const addToCartBtn = themeContainer.querySelector('[data-add-to-cart]');
    if (!addToCartBtn) {
      return;
    }

    const addToCartText = addToCartBtn.querySelector('[data-add-to-cart-text]');
    const isAvailable = !!fullVariant && fullVariant.available !== false;

    if (isAvailable) {
      addToCartBtn.removeAttribute('aria-disabled');
      addToCartBtn.removeAttribute('disabled');
      addToCartBtn.classList.remove('is-disabled');
      addToCartBtn.classList.remove('disabled-mws');
      addToCartBtn.closest('.product-form__cart-submit, .product-form__item--submit')?.classList.remove('disabled-mws');
      if (addToCartText) addToCartText.textContent = 'Add to cart';
    } else {
      addToCartBtn.setAttribute('aria-disabled', 'true');
      addToCartBtn.setAttribute('disabled', 'disabled');
      addToCartBtn.classList.add('disabled-mws');
      if (addToCartText) addToCartText.textContent = 'Sold out';
    }

    const form = scope.querySelector('form') || scope;
    if (form) {
      form.classList.toggle('product-form--variant-sold-out', !isAvailable);
    }

    const sectionIdForEvent = themeContainer.getAttribute('data-section-id') || '';
    if (window.jQuery && sectionIdForEvent) {
      const eventName = `variantChange.slideshow-${sectionIdForEvent}`;
      window.jQuery(themeContainer).trigger(window.jQuery.Event(eventName, { variant: fullVariant }));
    }
  }

  // Directly updates price + add-to-cart DOM, bypassing the theme's own event system
  // (which conflicts with the APO app's async lookups for overflow variants).
  function updatePriceAndCart(scope, fullVariant) {
    const themeContainer = getThemeContainer(scope);
    if (!themeContainer) { return; }

    // --- Price ---
    const priceOuter = themeContainer.querySelector('[data-price]');
    if (priceOuter) {
      priceOuter.classList.remove('price--unavailable');
      priceOuter.removeAttribute('aria-hidden');

      const regularBlock = priceOuter.querySelector('.price__regular');
      const compareBlock = priceOuter.querySelector('.price__compare');
      const sale1Block = priceOuter.querySelector('.price__sale1');

      const regularMoneyEl = priceOuter.querySelector('.price__regular [data-regular-price] .money');
      const comparePriceEl = priceOuter.querySelector('.price__compare .orginal');

      if (regularMoneyEl) regularMoneyEl.textContent = formatMoney(fullVariant.price);

      const isOnSale = fullVariant.compare_at_price > fullVariant.price;
      const innerPriceDl = priceOuter.querySelector('dl.price');

      if (isOnSale) {
        if (comparePriceEl) comparePriceEl.textContent = formatMoney(fullVariant.compare_at_price);
        if (innerPriceDl) innerPriceDl.classList.add('price--on-sale');
        if (compareBlock) compareBlock.style.display = '';
      } else {
        if (comparePriceEl) comparePriceEl.textContent = '';
        if (innerPriceDl) innerPriceDl.classList.remove('price--on-sale');
        if (compareBlock) compareBlock.style.display = 'none';
      }

      // Force only ONE price element visible: hide .price__sale1 (unknown app),
      // show only our regular/compare block, which we fully control.
      if (sale1Block) sale1Block.style.display = 'none';
      if (regularBlock) regularBlock.style.display = '';

      if (!fullVariant.available) {
        priceOuter.classList.add('price--sold-out');
      } else {
        priceOuter.classList.remove('price--sold-out');
      }

      if (sale1Block) {
        sale1Block.textContent = formatMoney(fullVariant.price)
        sale1Block.style.display = ''
        regularBlock.style.display = 'none'

      }
    }
    syncAddToCartState(scope, fullVariant);
  }

  async function onOptionChange() {
    const scope = getScope();
    if (!scope) return;

    const values = getCurrentSelections(scope);
    const variant = findVariant(values);
    const hiddenSelect = document.getElementById(`ProductSelect-${sectionId}`);

    if (!variant || !hiddenSelect) {
      syncAddToCartState(scope, { available: false });
      return;
    }

    lastKnownSelections = { option1: values[0], option2: values[1], option3: values[2] };

    let opt = hiddenSelect.querySelector(`option[value="${variant.id}"]`);
    if (!opt) {
      opt = new Option(variant.title, variant.id);
      hiddenSelect.appendChild(opt);
    }

    hiddenSelect.value = variant.id;
    hiddenSelect.dispatchEvent(new Event('change', { bubbles: true }));

    const fullVariant = await fetchFullVariant(variant.id);
    updatePriceAndCart(scope, fullVariant);

  // REMOVED: cartIdInput.value = variant.id  ← do not touch this field manually

  const url = new URL(window.location.href);
  url.searchParams.set('variant', variant.id);
  window.history.replaceState({}, '', url.toString());

  // Let MWS own the cart id + properties from here
  document.dispatchEvent(
    new CustomEvent('mwApo::INIT_INLINE_ON_CHANGE_VARIANT', { bubbles: true })
  );

  updateRondellForVariant(fullVariant);
}
function showLoaderInFirstSelect(scope) {
  const allSelects = scope.querySelectorAll('select[data-index]');
  if (allSelects.length === 0) return;

  allSelects.forEach(sel => {
    sel.disabled = true;
    sel.dataset.loaderActive = 'true';
    sel.innerHTML = '';
    const loaderOption = new Option('Loading options', '', true, true);
    loaderOption.disabled = true;
    sel.appendChild(loaderOption);
  });

  let dots = 0;
  window.__loaderInterval = setInterval(() => {
    dots = (dots + 1) % 4;
    allSelects.forEach(sel => {
      const opt = sel.querySelector('option[disabled]');
      if (opt) opt.textContent = 'Loading options' + '.'.repeat(dots);
    });
  }, 400);
}

function clearLoaderFromSelect(scope) {
  clearInterval(window.__loaderInterval);
  const allSelects = scope.querySelectorAll('select[data-index]');
  allSelects.forEach(sel => {
    sel.disabled = false;
    delete sel.dataset.loaderActive;
  });
}
function updateRondellForVariant(fullVariant) {
  const targetId = fullVariant.featured_image?.id;
  if (!targetId) { return; }

  const items = document.querySelectorAll('.rondell-item');
  let matchedItem = null;

  items.forEach(item => {
    const img = item.querySelector('.rondell-item-image, img');
    if (!img || !img.id) return;
    // img.id looks like "gs45545034842333" -> strip the "gs" prefix
    const imgIdNum = img.id.replace(/^gs/, '');
    if (imgIdNum === String(targetId)) {
      matchedItem = item;
    }
  });

  if (matchedItem) {
    if (!matchedItem.classList.contains('rondell-item-focused')) matchedItem.click();
  }
  }

function applyVariantSelections(scope, variant) {
  scope.querySelectorAll('[data-index]').forEach(el => {
    const idx = el.dataset.index; // "option1" | "option2" | "option3"
    const targetValue = variant[idx];
    if (targetValue == null) return;

    if (el.type === 'radio') {
      el.checked = (el.value === targetValue);
    } else {
      el.value = targetValue;
    }
  });
  }

  window.__debugOnOptionChange = onOptionChange;
  window.__debugGetSelections = () => getCurrentSelections(getScope());
  window.__debugAllVariants = () => allVariants;

  document.addEventListener('DOMContentLoaded', async () => {
  const scope = getScope();
  if (!scope) { return; }
  
  showLoaderInFirstSelect(scope); 
  await loadAllVariants();
  rebuildOptionSelects(scope);
  clearLoaderFromSelect(scope);

  if (initialVariantIdFromUrl) {
    const requestedVariant = allVariants.find(v => String(v.id) === String(initialVariantIdFromUrl));
    if (requestedVariant) {
      applyVariantSelections(scope, requestedVariant);
    }
  }

  // Filter the dependent dropdowns (option2/option3) down to only the values
  // valid for the currently selected option1 — otherwise they still show
  // every value from the whole dataset until the user manually changes something.
  reassertDependentSelect(scope, 'option1');

  scope.querySelectorAll('[data-index]').forEach(el => {
    el.addEventListener('change', (e) => {
      reassertDependentSelect(scope, e.target.dataset.index);
      onOptionChange();

      clearTimeout(window.__reassertTimer);
      window.__reassertTimer = setTimeout(() => {
        reassertDependentSelect(scope, e.target.dataset.index);
        onOptionChange();
      }, 700);
    });
  });

  onOptionChange();
  });
})();